import { profileDataReducer } from './profileData/slice';
import { authReducer } from './auth/slice';
import { Reducer, combineReducers } from '@reduxjs/toolkit';
import { RootState } from '../containers/common/utils/root-state';
import { profilePictureReducer } from './profilePicture/slice';

const rootReducer: Reducer<RootState> = combineReducers({
  profileData: profileDataReducer,
  profilePicture: profilePictureReducer,
  auth: authReducer
});

export default rootReducer;
